//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  angular.module('curalate')
    .directive('switch', () => ({
      restrict: 'E',
      scope: {
        on: '=',
        onToggled: '&',
      },
      link(scope, element, attrs) {
        attrs.$set('tabindex', '-1');

        scope.$watch('on', (toggleState, prevToggleState) => {
          element.toggleClass('switch-on', !!scope.on);

          if (toggleState !== prevToggleState) {
            scope.onToggled({ toggleState });
          }
        });

        function toggleIfEnabled() {
          if (!attrs.disabled) {
            scope.$apply('on = !on');
          }
        }

        element
                    .click(toggleIfEnabled)
                    .keypress((event) => {
                      if (event.which === 32) {
                        toggleIfEnabled();
                      }
                    });
      },
    }));
})();
